import { render, staticRenderFns } from "./BrandableAddonModal.vue?vue&type=template&id=f8f10ee0&scoped=true&"
import script from "./BrandableAddonModal.vue?vue&type=script&lang=js&"
export * from "./BrandableAddonModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandableAddonModal.vue?vue&type=style&index=0&id=f8f10ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f10ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f10ee0')) {
      api.createRecord('f8f10ee0', component.options)
    } else {
      api.reload('f8f10ee0', component.options)
    }
    module.hot.accept("./BrandableAddonModal.vue?vue&type=template&id=f8f10ee0&scoped=true&", function () {
      api.rerender('f8f10ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/AddonModal/BrandableAddonModal.vue"
export default component.exports